var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useState, useEffect, useRef } from 'react';
export const useMyAds = () => {
  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(true);
  const [ads, setAds] = useState([]);
  useEffect(() => {
    isMounted.current = true;
    const getADS = () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        const request = yield fetch('https://apigw.olx.com.br/mydata/v1/data?status=published&page=1&page_size=2', {
          credentials: 'include'
        });
        const response = yield request.json();
        if (!response.ads) return;
        const mapedAds = response.ads.map(ad => ({
          id: ad.adId,
          title: ad.title,
          url: "https://www.olx.com.br/vi/".concat(ad.listId),
          boostUrl: "https://pointsofsales.olx.com.br/?listId=".concat(ad.listId, "&action=boost&referral=DSMENU"),
          image: ad.url,
          price: ad.price,
          views: !ad.views ? '' : Number(ad.views) === 1 ? '1 visita' : "".concat(ad.views, " visitas")
        }));
        if (isMounted.current) setAds(mapedAds);
        // eslint-disable-next-line no-empty
      } catch (err) {} finally {
        if (isMounted.current) setIsLoading(false);
      }
    });
    getADS();
    return () => {
      isMounted.current = false;
    };
  }, []);
  return [ads, isLoading];
};